import { render } from "./MetricRegionMap.vue?vue&type=template&id=6625c49b"
import script from "./MetricRegionMap.vue?vue&type=script&lang=js"
export * from "./MetricRegionMap.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__